import React from 'react';
import { cn } from '../../utils/cn';

export interface ProgressProps
  extends React.HTMLAttributes<HTMLDivElement> {
  value?: number;
  max?: number;
  indicatorColor?: string;
}

const Progress = React.forwardRef<HTMLDivElement, ProgressProps>(
  ({ className, value = 0, max = 100, indicatorColor, ...props }, ref) => {
    const percentage = Math.min(Math.max((value / max) * 100, 0), 100);

    return (
      <div
        ref={ref}
        className={cn(
          'relative h-4 w-full overflow-hidden rounded-full bg-gray-100',
          className
        )}
        {...props}
      >
        <div
          className="h-full w-full flex-1 bg-blue-600 transition-all"
          style={{
            transform: `translateX(-${100 - percentage}%)`,
            ...(indicatorColor ? { backgroundColor: indicatorColor } : {}),
          }}
        />
      </div>
    );
  }
);
Progress.displayName = 'Progress';

export { Progress };